export class WindowsServiceStatusModel {
  public serviceName: string;
  public displayName: string;
  public status: string;
  public isRunning: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/models/windows-service-status.model.ts